import { logDispatcher } from "src/app/core/decorators/state.decorators";
import { ServiceConceptType } from "../../interfaces/serviceConceptType";
import { InvoiceType } from "../../interfaces/invoiceType";
import { MassiveResponse } from "src/app/modules/massive-actions/models/massive.model";

export namespace ServiceConceptTypeActions {

  @logDispatcher
  export class GetServiceConceptsType {
    static readonly type = "[ServiceConceptsType] GetServiceConceptsType"
    constructor() {}
  }

  @logDispatcher
  export class GetServiceConceptsTypeFiltered {
    static readonly type = "[ServiceConceptsType] GetServiceConceptsTypeFiltered"
    constructor(public name: string, public isFixed: boolean | '', public isMeal: boolean | '', public isActive: boolean | '') {}
  }

  @logDispatcher
  export class GetServiceConceptsTypeSuccess {
    static readonly type = "[ServiceConceptsType] GetServiceConceptsSuccess"
    constructor(public serviceConceptsTypes: ServiceConceptType[]) {}
  }

  @logDispatcher
  export class GetServiceConceptTypeDetailsSuccess {
    static readonly type = "[ServiceConceptsType] GetServiceConceptTypeDetailsSuccess"
    constructor(public serviceConceptType: ServiceConceptType) {}
  }

  @logDispatcher
  export class GetInvoiceTypes {
    static readonly type = "[ServiceConceptsType] GetInvoiceTypes"
    constructor() {}
  }

  @logDispatcher
  export class GetInvoiceTypesSuccess {
    static readonly type = "[ServiceConceptsType] GetInvoiceTypesSuccess"
    constructor(public invoiceTypes: InvoiceType[]) {}
  }


  @logDispatcher
  export class AddServiceConceptsType {
    static readonly type = "[ServiceConceptsType] AddServiceConceptsType"
    constructor(public serviceConceptType: ServiceConceptType) {}
  }

  @logDispatcher
  export class AddServiceConceptsTypeSuccess {
    static readonly type = "[ServiceConceptsType] AddServiceConceptsTypeSuccess"
    constructor(public serviceConceptType: ServiceConceptType) {}
  }

  @logDispatcher
  export class EditServiceConceptsType {
    static readonly type = "[ServiceConceptsType] EditServiceConceptsType"
    constructor(public connectionId: string, public channel: string) {}
  }

  @logDispatcher
  export class EditServiceConceptsTypeSuccess {
    static readonly type = "[ServiceConceptsType] EditServiceConceptsSuccessType"
    constructor(public massiveResponse: MassiveResponse) {}
  }

  @logDispatcher
  export class ToggleAllSelected {
    static readonly type = "[ServiceConceptsType] ToggleAllSelected"
    constructor(public column: string, public selected: boolean) {}
  }

  @logDispatcher
  export class EditTableCell {
    static readonly type = "[ServiceConceptsType] EditTableCell"
    constructor(public rowId: number, public fieldName: string, public newValue: any) {}
  }

  @logDispatcher
  export class Error {
      static readonly type = '[ServiceConceptsType] Error';
      constructor(public error: any, public details: string) { }
  }

  @logDispatcher
  export class SetDefaultState  {
      static readonly type = '[ServiceConceptsType] SetDefaultState';
      constructor(public serviceConceptTypeDefaults: ServiceConceptType) {}
  }

  @logDispatcher
  export class SetDefaults  {
      static readonly type = '[ServiceConceptsType] SetDefaults';
      constructor() {}
  }

  @logDispatcher
  export class SetIsListSmaller {
    static readonly type = '[ServiceConceptsType] SetIsListSmaller';
    constructor(public isListSmaller: boolean) { }
  }
}
